import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Button } from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import { usePets } from '../../../hooks/patients/usePets';
import { Box, List, IconButton } from '@mui/material';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PetView from './PetView';
import SearchBox from '../../common/forms/SearchBox';
import { Divider } from '@mui/material';
import PetForm from '../forms/PetForm';
import { getPetById } from '../../../api/petService';
import { userHasAccess } from '../../../utils/userHasAccess';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function Pets() {

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        resetParent();
    };

    const [selectedPet, setSelectedPet] = React.useState(null);
    const [viewOpen, setViewOpen] = React.useState(false);
    const [petFormOpen, setPetFormOpen] = React.useState(false);
    const [petFormMode, setPetFormMode] = React.useState("edit");

    const { pets, loading, loadMore, searchFunction, resetParent } = usePets(open, 1, 10);

    const handleListItemClick = (pet) => {
        setSelectedPet(pet);
        setViewOpen(true);
    };

    const handleEditPet = (pet) => {
        setSelectedPet(pet)
        setPetFormMode("edit");
        setPetFormOpen(true);
    };

    const onSavePetSuccess = async () => {
        await resetParent();
        const updatedPet = await getPetById(selectedPet.id);
        setSelectedPet(updatedPet);
    };

    return (
        <>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <PetsIcon fontSize='large' color='secondary' />
            </ListItemIcon>
            <ListItemText 
                primary="Pets"
                secondary="view and manage pets"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <Stack spacing={2}>
                    <Typography variant="h6">Pets</Typography>
                    <SearchBox searchFunction={searchFunction} resetParent={resetParent} />
                    <Divider />
                </Stack>
            </DialogTitle>
            <DialogContent>
                <List sx={{ minHeight: 500 }}>
                    {pets?.data?.map((pet) => (
                    <ListItem
                        key={pet.id}
                        secondaryAction={
                        <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                            <VerticalHamburgerMenu
                            options={[
                                { 
                                    id: 1, 
                                    name: 'View',
                                    callback: () => handleListItemClick(pet),
                                    disabled: !userHasAccess(SUB_MODULES.PETS, 1)
                                },
                                {
                                    id: 2,
                                    name: 'Edit',
                                    callback: () => handleEditPet(pet),
                                    disabled: !userHasAccess(SUB_MODULES.PETS, 2)
                                }
                            ]}
                            />
                        </Box>
                        }
                    >
                        <ListItemButton onClick={() => {if (userHasAccess(SUB_MODULES.PETS, 1)) handleListItemClick(pet)}}>
                            <ListItemIcon>
                                <PetsIcon fontSize='large' color='primary' />
                            </ListItemIcon>
                            <ListItemText
                            primary={`${pet.name}`}
                            secondary={`${pet.owner.first_name} ${pet.owner.last_name}`}
                            />
                        </ListItemButton>
                    </ListItem>
                    ))}
                </List>

                {/* Load More only shows if more pages exist */}
                {pets?.pagination?.page < pets?.pagination?.totalPages && (
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <IconButton 
                            onClick={loadMore}
                            sx={{
                                width: '100%',              // fill container width
                                justifyContent: 'center',   // center the icon horizontally
                                color: 'primary.main',      // use theme's primary color
                            }}
                        >
                            <KeyboardArrowDownIcon />
                        </IconButton>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <PetView 
            handleEditPet={handleEditPet}
            pet={selectedPet}
            open={viewOpen}
            onClose={() => setViewOpen(false)}
        />
        <PetForm 
            successCallback={onSavePetSuccess}
            pet={selectedPet}
            mode={petFormMode}
            open={petFormOpen}
            onClose={() => {
                setPetFormOpen(false);
            }}
        />
        </>
    );
}